import {createStyles} from '@material-ui/core';

import {defaultFont} from '../../styles/style';

export const style = createStyles({
  form: {
    marginTop: '5px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  form__item: {},
  form__error: {
    ...defaultFont,
    fontSize: '14px',
  },
});
